import CONFIGDATA from '../mockData';

export default CONFIGDATA;
